import { useEffect, useState } from "react";

export default function DoorReveal({ onDone }) {
  const [phase, setPhase] = useState("key"); // key -> open

  useEffect(() => {
    const t1 = setTimeout(() => setPhase("open"), 750);
    const t2 = setTimeout(onDone, 2000);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [onDone]);

  return (
    <div className="door-stage" data-testid="door-reveal">
      <div className={`door-panel door-left ${phase === "open" ? "door-open-left" : ""}`} data-testid="door-left" />
      <div className={`door-panel door-right ${phase === "open" ? "door-open-right" : ""}`} data-testid="door-right" />
      <div className="door-seam-glow" />
      <div className={`keyhole-wrap ${phase === "open" ? "turning" : ""}`} data-testid="door-keyhole">
        <div className="keyhole-head" />
        <div className="keyhole-slot" />
      </div>
    </div>
  );
}
